/** Deep link into /delivery-logs pre-filtered to one notification.
 *
 * Built with the QuerySearch serializer so the DSL is canonical (round-trips
 * through the EDL page's parser). A bounded 7-day `created` window rides along
 * — it is load-bearing on the delivery-logs page (partition pruning), and it's
 * the SAME UTC-datetime window the page seeds itself (createdWindow.ts).
 */
import { serialize, type FilterNode } from '@/components/QuerySearch';
import { createdWindowNode } from '@/features/delivery-logs/createdWindow';

export function deliveryLogsUrl(notificationId: number): string {
  const nodes: FilterNode[] = [
    {
      kind: 'cond',
      namespace: 'notification',
      operator: 'exact',
      value: String(notificationId),
    },
    createdWindowNode(),
  ];
  return `/delivery-logs?q=${encodeURIComponent(serialize(nodes))}`;
}
